import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
} from 'react-admin';

const FeaturedCampaignCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="campaign_id" />
    </SimpleForm>
  </Create>
);

export default FeaturedCampaignCreate;
